import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import ProductTableRow from "./ProductTableRow";

export default function ProductTable({
  rows,
  getLineForLot,
  getPriceOverride,
  onAdd,
  onPriceConfig,
  disabled,
}) {
  if (!rows.length) {
    return (
      <Typography
        variant="body2"
        color="text.secondary"
        sx={{ py: 4, textAlign: "center" }}
      >
        No products found. Try another search or category.
      </Typography>
    );
  }

  return (
    <TableContainer sx={{ overflowX: "auto" }}>
      <Table size="small" stickyHeader>
        <TableHead>
          <TableRow>
            <TableCell>Image</TableCell>
            <TableCell>Product</TableCell>
            <TableCell>Article code</TableCell>
            <TableCell>Delivery</TableCell>
            <TableCell align="right">Selling Price</TableCell>
            <TableCell align="right">MRP</TableCell>
            <TableCell align="center">Price Config</TableCell>
            <TableCell align="right">Available</TableCell>
            <TableCell align="right">Qty</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row) => {
            const productId = String(row.admin_product_id || row.id || "");
            return (
              <ProductTableRow
                key={row.id}
                row={row}
                cartLine={getLineForLot(productId)}
                priceOverride={getPriceOverride?.(productId)}
                onAdd={onAdd}
                onPriceConfig={onPriceConfig}
                disabled={disabled}
              />
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
